import { OVERLAY_TYPES, OVERLAY_TYPE_ICONS, OVERLAY_DEFAULT_SIZE } from './overlayDefaults';
import styles from './LayoutEditor.module.css';

export default function OverlayPalette({ onAddOverlay }) {
  const handleDragStart = (e, type) => {
    e.dataTransfer.setData('overlayType', type);
    e.dataTransfer.effectAllowed = 'copy';
  };

  return (
    <div className={styles.palette}>
      <div className={styles.paletteTitle}>Overlays</div>
      <div className={styles.paletteHint}>Click or drag to add</div>
      {OVERLAY_TYPES.map(({ value, label }) => (
        <button
          type="button"
          aria-label={`Add ${label}`}
          key={value}
          className={styles.paletteChip}
          draggable
          onDragStart={e => handleDragStart(e, value)}
          onClick={() => {
            const size = OVERLAY_DEFAULT_SIZE[value];
            onAddOverlay(value, { x: (1 - size.width) / 2, y: (1 - size.height) / 2, ...size });
          }}
        >
          <span className={styles.paletteIcon}>{OVERLAY_TYPE_ICONS[value]}</span>
          <span className={styles.paletteLabel}>{label}</span>
        </button>
      ))}
    </div>
  );
}
